import { Component, OnInit } from '@angular/core';
import {StaffFormDialog} from '@ft/core';

@Component({
  selector: 'physician-staff-dialog',
  templateUrl: './physician-staff-dialog.component.html',
})
export class PhysicianStaffDialogComponent extends StaffFormDialog {
}
